import { cloneVNode as v, h as w, Fragment as S } from "vue";
import { match as k } from "./index342.js";
var A = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(A || {}), E = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(E || {});
function H({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...o }) {
  var i;
  let s = j(r, n), u = Object.assign(o, { props: s });
  if (e || t & 2 && s.static) return g(u);
  if (t & 1) {
    let f = (i = s.unmount) == null || i ? 0 : 1;
    return k(f, { 0() {
      return null;
    }, 1() {
      return g({ ...o, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return g(u);
}
function g({ props: e, attrs: t, slots: n, slot: r, name: o }) {
  var i, s;
  let { as: u, ...f } = N(e, ["unmount", "static"]), l = (i = n.default) == null ? void 0 : i.call(n, r), h = {};
  if (r) {
    let c = !1, m = [];
    for (let [d, p] of Object.entries(r)) typeof p == "boolean" && (c = !0), p === !0 && m.push(d);
    c && (h["data-headlessui-state"] = m.join(" "));
  }
  if (u === "template") {
    if (l = b(l ?? []), Object.keys(f).length > 0 || Object.keys(t).length > 0) {
      let [c, ...m] = l ?? [];
      if (!P(c) || m.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(f).concat(Object.keys(t)).map((a) => a.trim()).filter((a, y, O) => O.indexOf(a) === y).sort((a, y) => a.localeCompare(y)).map((a) => `  - ${a}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((a) => `  - ${a}`).join(`
`)].join(`
`));
      let d = j((s = c.props) != null ? s : {}, f, h), p = v(c, d, !0);
      for (let a in d) a.startsWith("on") && (p.props || (p.props = {}), p.props[a] = d[a]);
      return p;
    }
    return Array.isArray(l) && l.length === 1 ? l[0] : l;
  }
  return w(u, Object.assign({}, f, h), { default: () => l });
}
function b(e) {
  return e.flatMap((t) => t.type === S ? b(t.children) : [t]);
}
function j(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let o in r) o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n) Object.assign(t, { [r](o, ...i) {
    let s = n[r];
    for (let u of s) {
      if (o instanceof Event && o.defaultPrevented) return;
      u(o, ...i);
    }
  } });
  return t;
}
function x(e) {
  let t = Object.assign({}, e);
  for (let n in t) t[n] === void 0 && delete t[n];
  return t;
}
function N(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
function P(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
export {
  A as Features,
  E as RenderStrategy,
  x as compact,
  N as omit,
  H as render
};
